import React from 'react';
import SvgIcon from './svgIcon';

const SvgExportIcon = props => {
  return (
    <SvgIcon width={16} height={16} {...props} role="presentation">
      <path
        fill="currentColor"
        d="M11.7.3c-.2-.2-.4-.3-.7-.3h-1v3c0 .6-.4 1-1 1H4c-.6 0-1-.4-1-1V0H1C.4 0 0 .4 0 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V5c0-.3-.1-.5-.3-.7l-4-4zM13 14H3v-3c0-.6.4-1 1-1h8c.6 0 1 .4 1 1v3zM7 0h2v3H7V0z"
      />
    </SvgIcon>
  );
};

export default SvgExportIcon;
